<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :options="[
        { type: 'text', label: '평가자'},
        { type: 'date', label: '평가일'}
      ]"/>

    <!-- 평가대상 -->
    <div class="mb-6">
      <p class="title mb-5"><i class="dot"></i>평가대상</p>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">부서명</div>
          <span v-if="isPrint" class="print-input"> {{ form.evaluation.companyName }} </span>
          <CompanySelector v-else :readonly="board.readonly" class="w-full flex-1" :fieldId="form.stdInfo.field_id" v-model="form.evaluation.companyId" placeholder="선택"
                           @select="(company)=>{
                             form.evaluation.company = company;
                             form.evaluation.companyName = company.com_name
                           }"></CompanySelector>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">피평가자</div>
          <p v-if="isPrint" class="print-input">{{ form.evaluation.person }}</p>
          <ml-input v-else v-model="form.evaluation.person" class="w-full flex-1"/>
        </div>
<!--        <div class="col-span-4 flex items-center">-->
<!--          <div class="label-text mr-4">평가일</div>-->
<!--          <p v-if="isPrint" class="print-input">{{ form.evaluation.date }}</p>-->
<!--          <date-selector :readonly="board.readonly" v-else v-model="form.evaluation.date" class="w-full flex-1" />-->
<!--        </div>-->
      </div>
    </div>

    <!-- 평가표 -->
    <div class="mb-6">
      <p class="title mb-5"><i class="dot"></i>평가표</p>
      <div class="border-top border-left">
        <div class="grid" style="grid-template-columns: 52px 160px 709fr 82px 82px 82px 389fr">
          <div class="p-4 border-right border-bottom text-center grid items-center font-bold" style="color:#3C3C3C">No.</div>
          <div class="p-4 border-right border-bottom text-center grid items-center font-bold" style="color:#3C3C3C">평가항목</div>
          <div class="p-4 border-right border-bottom text-center grid items-center font-bold" style="color:#3C3C3C">세부내용</div>
          <div class="p-4 border-right border-bottom text-center grid items-center font-bold" style="color:#3C3C3C">양호</div>
          <div class="p-4 border-right border-bottom text-center grid items-center font-bold" style="color:#3C3C3C">미흡</div>
          <div class="p-4 border-right border-bottom text-center grid items-center font-bold" style="color:#3C3C3C">해당없음</div>
          <div class="p-4 border-right border-bottom text-center grid items-center font-bold" style="color:#3C3C3C">비고(보완계획)</div>
        </div>

        <div v-for="inspect in form.inspectList">
          <div v-if="typeof inspect === 'string'" class="p-4 border-right border-bottom font-bold" style="color:#3C3C3C">{{inspect}}</div>
          <div v-else class="grid" style="grid-template-columns: 52px 160px 709fr 82px 82px 82px 389fr">
            <div class="p-4 border-right border-bottom text-center grid items-center">{{ inspect.No }}</div>
            <div class="p-4 border-right border-bottom text-center grid items-center">{{ inspect.평가항목 }}</div>
            <div class="p-4 border-right border-bottom grid">
              <span v-for="세부항목 in inspect.세부내용" class="flex"><i class="dot small black mt-3"/>{{세부항목}}</span>
            </div>
            <div class="p-4 border-right border-bottom text-center grid items-center justify-center">
              <span v-if="isPrint" class="print-checkbox ml-2"><i><feather-icon v-if="inspect.is_checked === '양호'" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
              <vs-checkbox v-else class="m-0" :checked="inspect.is_checked === '양호'" @change="inspect.is_checked = '양호'"/>
            </div>
            <div class="p-4 border-right border-bottom text-center grid items-center justify-center">
              <span v-if="isPrint" class="print-checkbox ml-2"><i><feather-icon v-if="inspect.is_checked === '미흡'" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
              <vs-checkbox v-else class="m-0" :checked="inspect.is_checked === '미흡'" @change="inspect.is_checked = '미흡'"/>
            </div>
            <div class="p-4 border-right border-bottom text-center grid items-center justify-center">
              <span v-if="isPrint" class="print-checkbox ml-2"><i><feather-icon v-if="inspect.is_checked === '해당없음'" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
              <vs-checkbox v-else class="m-0" :checked="inspect.is_checked === '해당없음'" @change="inspect.is_checked = '해당없음'"/>
            </div>
            <div class="px-1 border-right border-bottom text-center grid items-center">
              <span v-if="isPrint">{{inspect.note}}</span>
              <ml-input v-else class="w-full" v-model="inspect.note"/>
            </div>
          </div>
        </div>


      </div>
    </div>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import DateSelector from "@/components/selector/DateSelector.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import FileUploader from '@/components/FileUploader'
import CompanySelector from '@/components/selector/CompanySelector.vue'
import companyAction from '@/store/company/companyAction'
import TableInspect from "@/components/TableInspect";

export default {
  components: {
    TableInspect,
    CompanySelector,
    FileUploader,
    DateSelector,
    FileUploadModule,
    TableInspectMerge,
    FieldSelectModule,
    PhotoUploadGridModule,
    DisasterClassSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    companyAction () {
      return companyAction
    },
    allCheck () {
      let isCheck = this.form.completionPlan.length > 0
      for (const item of this.form.completionPlan) {
        if (!item.is_checked) {
          isCheck = false
          break;
        }
      }
      return isCheck;
    }
  },
  data() {
    return {
      form: {
        stdInfo: {},
        evaluation: {
          company: {},
          companyId: '',
          companyName: '',
          person: '',
          date: '',
        },
        inspectList: [
          "안전보건 관리체제",
          {
            No: 1,
            평가항목: "일반원칙",
            세부내용: ["수급･수탁업체의 안전보건 체계 구축 적정 여부(안전관리 비용 확보, 안전 전문인력에 의한 관리 등)"],
            is_checked: "", // 양호, 미흡, 해당없음
            note: ''
          },
          {
            No: 2,
            평가항목: "계획수립",
            세부내용: ["시민 재해 예방 활동에 대한 수급인의 이행계획 적정 여부"],
            is_checked: "", // 양호, 미흡, 해당없음
            note: ''
          },
          {
            No: 3,
            평가항목: "역할 및 책임",
            세부내용: ["이행계획 추진을 위한 구성원의 역할 분담(관리부서, 사업장)"],
            is_checked: "", // 양호, 미흡, 해당없음
            note: ''
          },


          "실행수준",
          {
            No: 4,
            평가항목: "안전점검",
            세부내용: ["안전점검 및 모니터링(점검 후 개선조치)"],
            is_checked: "", // 양호, 미흡, 해당없음
            note: ''
          },
          {
            No: 5,
            평가항목: "이행확인",
            세부내용: ["안전조치 이행여부 확인(위탁업체의 지도조언에 대한 이행 포함)"],
            is_checked: "", // 양호, 미흡, 해당없음
            note: ''
          },
          {
            No: 6,
            평가항목: "교육 및 기록",
            세부내용: ["법정 의무교육 이행 및 3년간 안전교육, 훈련 실적"],
            is_checked: "", // 양호, 미흡, 해당없음
            note: ''
          },
          {
            No: 7,
            평가항목: "유해･위험요인 점검",
            세부내용: ["유해･위험요인의 주기적인 점검(긴급수시 점검, 일별 점검 등)"],
            is_checked: "", // 양호, 미흡, 해당없음
            note: ''
          },


          "운영관리",
          {
            No: 8,
            평가항목: "안전관리 규정",
            세부내용: ["법정 안전관리 규정, 지침 및 매뉴얼 구비 여부"],
            is_checked: "", // 양호, 미흡, 해당없음
            note: ''
          },
          {
            No: 9,
            평가항목: "비상대책",
            세부내용: ["재난발생시 대피 및 피해 최소화 대책", "(보고 및 대응절차, 유관기관 비상 연락망 마련 등 )"],
            is_checked: "", // 양호, 미흡, 해당없음
            note: ''
          },


          "재해발생 수준",
          {
            No: 10,
            평가항목: "시민재해 현황",
            세부내용: ["최근 3년간 중대재해 발생 현황 및 중대재해로 인한 행정처분 유무, 처분 정도에 대한 현황"],
            is_checked: "", // 양호, 미흡, 해당없음
            note: ''
          },
        ],
        completionPlan: [],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    handleClickPush (form_key) {
      this.form[form_key].push({
        is_checked: '',
        no: '',
        법정교육명: '',
        교육대상: '',
        이수대상: '',
        주기: '',
        교육시기_시작일: '',
        교육시기_종료일: '',
        교육기관: '',
        교육이수증: {}
      })
    },
    handleClickRemove (form_key) {
      for (let i = 0; i < this.form[form_key].length; i++) {
        if (this.form[form_key][i].is_checked) {
          this.form[form_key].remove(this.form[form_key][i])
          i = -1
        }
      }
    },

    changePlanAllCheck () {
      const all = !this.allCheck
      for (const data of this.form.completionPlan) {
        data.is_checked = all
      }
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
.sign-module::v-deep {
  justify-content: normal !important;
  .sign-field {
    flex: 1;
    max-width: none;
  }
}
</style>


<!-- table -->
<style scoped lang="scss">
.style-table {
  border-left:1px solid #CDCDCD; border-top:1px solid #CDCDCD;
}
.style-table-item {
  padding: 0.5rem;
  display: flex; justify-content: center; align-items: center; border-right: 1px solid #CDCDCD; border-bottom: 1px solid #CDCDCD;
}
.style-table-head,
.style-table-body {
  display: grid; grid-template-columns: 40px 65px 189fr 189fr 150fr 150fr 400fr 189fr 189fr;
}
.style-table-head {
  .style-table-item {
    height: 50px;
    background-color: #f9f9f9;
  }
}
</style>

<!-- checkbox -->
<style scoped lang="scss">
.print-radio,
.print-checkbox {
  display: flex;
  align-items: center;
  margin-right: 1rem;

  & > i { width:20px; height: 20px; border:2px solid #cdcdcd; position: relative; margin-right: 6px; }
  & .feather-icon { transform: translateY(-4px); }
}

.print-radio {
  & > i { border-radius: 20px; }
}
</style>
